export default Object.freeze({
  bySiteAndDate: [],
  byDate: [],
  loading: true,
});
